module.exports = __webpack_public_path__ + "img/mv--hakari_sprite1.cc6b021c.png";